import {ProductBrandEnum} from "@/views/modules/product/product-brand/enum";
import {transformToMap} from "@/utils/common";

const getters = {
  // common
  keepAliveViews: state => state.common.keepAliveViews,
  navMenuTabs: state => state.common.navMenuTabs,
  countries: state => state.common.countries,
  markets: state => state.common.markets,
  adMarkets: state => state.common.adMarkets,
  authCountries: state => state.common.authCountries,
  authMarkets: state => state.common.authMarkets,
  marketOption: state => {
    return (state.common.markets || [])
      .map(v => ({id: Number(v.id), text: v.text + ':' + v.countryCode, countryCode: v.countryCode, market: v.text}))
  },
  marketMap: state => {
    return transformToMap((state.common.markets || [])
      .map(v => ({id: Number(v.id), text: v.text + ':' + v.countryCode, countryCode: v.countryCode, market: v.text})))
  },
  userGuideState: state => state.common.userGuideState,
  userGuideMenuPath: state => state.common.userGuideMenuPath,
  userGuideTaskData: state => state.common.userGuideTaskData,
  isNewUserTask: state => state.common.isNewUserTask,
  guideVisible: state => state.common.guideVisible,
  isShowNoviceGuide: state => state.common.isShowNoviceGuide,
  userGuideTaskItem: state => state.common.userGuideTaskItem,

  // user
  firstLogin: state => state.user.firstLogin,
  auth: state => state.user.auth,
  token: state => state.user.token,
  account: state => state.user.account,
  checkedUserState: state => state.user.checkedUserState,
  userInfo: state => state.user.userInfo,
  userMenus: state => state.user.userMenus,
  useLoadResources: state => state.user.useLoadResources,
  userResources: state => state.user.userResources,
  userOptions: state => state.user.userOptions,
  activeUserOptions: state => state.user.activeUserOptions,
  tenantPay: state => state.user.tenantPay,
  companyInfo: state => state.user.companyInfo,
  msgNumber: state => state.user.msgNumber,
  isPolling: state => state.user.isPolling,
  refreshMessage: state => state.user.refreshMessage,
  latestVersionId: state => state.user.latestVersionId,
  isMsgsGlobal: state=> state.user.isMsgsGlobal,

  // warehouse
  warehouseTree: state => state.warehouse.warehouseTree,
  activeWarehouseTree: state => state.warehouse.activeWarehouseTree,
  fbaWarehouseTree: state => state.warehouse.fbaWarehouseTree,
  activeFbaWarehouseTree: state => state.warehouse.activeFbaWarehouseTree,
  selfWarehouseTree: state => state.warehouse.selfWarehouseTree,
  activeSelfWarehouseTree: state => state.warehouse.activeSelfWarehouseTree,

  // product
  productBrands: state => state.product.productBrands,
  productBrandOptions: state => {
    return (state.product.productBrands || []).map(item => ({
      id: item.id,
      text: item.name
    }))
  },
  activeProductBrandOptions: state => {
    return (state.product.productBrands || [])
      .filter(item => item.state === ProductBrandEnum.status.ACTIVE)
      .map(item => ({
        id: item.id,
        text: item.name
      }))
  },
  activeProductCategoryTree: state => state.product.activeProductCategoryTree,
  productCategoryTree: state => state.product.productCategoryTree,
  allProductCategoryTree: state => state.product.allProductCategoryTree,

  // sale
  operationState: state => state.sale.operationState,

  // logistics
  logisticsOption: state => state.logistics.logisticsOption,
  activeLogisticsOption: state => state.logistics.activeLogisticsOption,

  // purchase
  supplier: state => state.purchase.supplier,
  activeSupplier: state => state.purchase.activeSupplier,

  // statistics

  openImport : state => state.statistics.openImport,

  // dashboard
  marketAuthType: state => state.user.marketAuthType,
  timezoneId: state => state.dashboard.timezoneId,
  timezoneText: state => state.dashboard.timezoneText,
  dashboardCurrency: state => state.dashboard.dashboardCurrency,
  countryMarket: state => state.dashboard.countryMarket,
};

export default getters
